import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
} from "react-router-dom";
import { Projects } from "./pages/Projects";
import { Resources } from "./pages/Resources";
import { Customers } from "./pages/Customers";
import { NotFound } from "./pages/NotFound";
import { PageInitial } from "./pages/PageInitial";
import { CreateProjects } from "./pages/Projects/CreateProject";
import { UpdateProject } from "./pages/Projects/UpdateProject";
import { UpdateCustomer } from "./pages/Customers/UpdateCustomers";
import PrivateRoute from "./components/PrivateRoute";
import { Scheduler } from "./pages/Scheduler";
import { Reports } from "./pages/Reports";
import { Areas } from "./pages/Configurations/Areas";
import { CreateAreas } from "./pages/Configurations/Areas/CreateAreas";
import { UpdateAreas } from "./pages/Configurations/Areas/UpdateAreas";
import { CreateCustomers } from "./pages/Customers/CreateCustomers";
import { CreateResources } from "./pages/Resources/CreateResource";
import { UpdateResource } from "./pages/Resources/UpdateResource";
import { Configurations } from "./pages/Configurations";
import { CostCenter } from "./pages/Configurations/CostCenter";
import { CreateCostCenter } from "./pages/Configurations/CostCenter/CreateCostCenter";
import { UpdateCostCenter } from "./pages/Configurations/CostCenter/UpdateCostCenter";
import { Synchronization } from "./pages/Configurations/Synchronization";
import { ApiToken } from "./pages/Configurations/ApiToken";
import { Positions } from "./pages/Configurations/Positions";
import { CreatePosition } from "./pages/Configurations/Positions/CreatePosition";
import { UpdatePosition } from "./pages/Configurations/Positions/UpdatePosition";
import { Permissions } from "./pages/Configurations/Permissions";
import { CreateGroup } from "./pages/Configurations/Permissions/CreateGroup";
import { UpdateGroup } from "./pages/Configurations/Permissions/UpdateGroup";
import { Unauthorized } from "./pages/Unauthorized";
import { CustomFields } from "./pages/Configurations/CustomFields";
import { Availabilities } from "./pages/Configurations/Availabilities";
import { Users } from "./pages/Configurations/Users";
import { UpdateUser } from "./pages/Configurations/Users/UpdateUser";
import { CreateUser } from "./pages/Configurations/Users/CreateUser";
import { NewTenant } from "./pages/NewTenant";
import SinglePrivateRoute from "./components/SinglePrivateRoute";
import { ProjectStatus } from "./pages/Configurations/ProjectStatus";
import { UpdateProjectStatus } from "./pages/Configurations/ProjectStatus/UpdateProjectStatus";
import { CreateProjectStatus } from "./pages/Configurations/ProjectStatus/CreateProjectStatus";
import { Holidays } from "./pages/Configurations/Holidays";
import { CreateHoliday } from "./pages/Configurations/Holidays/CreateHoliday";
import { UpdateHoliday } from "./pages/Configurations/Holidays/UpdateHoliday";
import { AccountConfiguration } from "./pages/Configurations/AccountConfiguration";
import { UserProfile } from "./pages/UserProfile";
import { Auditoria } from "./pages/Auditoria";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Página inicial protegida */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<PageInitial />} />
        <Route path="/scheduler" element={<Scheduler />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/create" element={<CreateProjects />} />
        <Route path="/projects/update/:id" element={<UpdateProject />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/create" element={<CreateResources />} />
        <Route path="/resources/update/:id" element={<UpdateResource />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/create" element={<CreateCustomers />} />
        <Route path="/customers/update/:id" element={<UpdateCustomer />} />

        {/* Outras rotas de configurações */}
        <Route path="/configurations" element={<Configurations />} />
        <Route path="/configurations/areas" element={<Areas />} />
        <Route path="/configurations/areas/create" element={<CreateAreas />} />
        <Route
          path="/configurations/areas/update/:id"
          element={<UpdateAreas />}
        />
        <Route path="/configurations/costCenter" element={<CostCenter />} />
        <Route
          path="/configurations/costCenter/create"
          element={<CreateCostCenter />}
        />
        <Route
          path="/configurations/costCenter/update/:id"
          element={<UpdateCostCenter />}
        />
        <Route path="/configurations/positions" element={<Positions />} />
        <Route
          path="/configurations/positions/create"
          element={<CreatePosition />}
        />
        <Route
          path="/configurations/positions/update/:id"
          element={<UpdatePosition />}
        />
        <Route
          path="/configurations/projectstatus"
          element={<ProjectStatus />}
        />
        <Route
          path="/configurations/projectstatus/create"
          element={<CreateProjectStatus />}
        />
        <Route
          path="/configurations/projectstatus/update/:id"
          element={<UpdateProjectStatus />}
        />
        <Route path="/configurations/permissions" element={<Permissions />} />
        <Route
          path="/configurations/permissions/create"
          element={<CreateGroup />}
        />
        <Route
          path="/configurations/permissions/update/:id"
          element={<UpdateGroup />}
        />
        <Route path="/configurations/users" element={<Users />} />
        <Route path="/configurations/users/create" element={<CreateUser />} />
        <Route
          path="/configurations/users/update/:id"
          element={<UpdateUser />}
        />
        <Route
          path="/configurations/availabilities"
          element={<Availabilities />}
        />
        <Route path="/configurations/customFields" element={<CustomFields />} />
        <Route path="/configurations/holidays" element={<Holidays />} />
        <Route
          path="/configurations/holidays/create"
          element={<CreateHoliday />}
        />
        <Route
          path="/configurations/holidays/update/:id"
          element={<UpdateHoliday />}
        />
        <Route path="/configurations/tokens" element={<ApiToken />} />
        <Route
          path="/configurations/synchronization"
          element={<Synchronization />}
        />
        <Route
          path="/configurations/financial"
          element={<AccountConfiguration />}
        />
        <Route path="/configurations/audit" element={<Auditoria />} />
        <Route path="/user-profile" element={<UserProfile />} />
      </Route>

      {/* Rota exclusiva para tenant */}
      <Route element={<SinglePrivateRoute />}>
        <Route path="/new-tenant" element={<NewTenant />} />
      </Route>

      {/* Rotas públicas */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />
    </>
  )
);
